module.exports = __webpack_public_path__ + "img/img_brand22.d842f7c9.jpg";